import { z } from "zod"
import { DEFAULT_PAGE_INDEX } from "@/hooks/useFilters"

export const FIXTURE_VALIDATION_PAGE_SIZE = 25

export const fixtureValidationStatusSchema = z.enum(["pass", "fail"])

export const fixtureValidationCountsSchema = z.object({
  gondola: z.number().int().nullable(),
  wall: z.number().int().nullable(),
  endcap: z.number().int().nullable(),
})

export const fixtureValidationQuerySchema = z.object({
  status: fixtureValidationStatusSchema.optional(),
  floorPlanRef: z.string().trim().optional(),
  pageIndex: z.coerce.number().int().min(0).default(DEFAULT_PAGE_INDEX),
  pageSize: z.coerce.number().int().min(1).max(100).default(FIXTURE_VALIDATION_PAGE_SIZE),
})

export type FixtureValidationStatus = z.infer<typeof fixtureValidationStatusSchema>
export type FixtureValidationCounts = z.infer<typeof fixtureValidationCountsSchema>
export type FixtureValidationFilters = z.infer<typeof fixtureValidationQuerySchema>

export type FixtureValidationSummary = {
  total: number
  passed: number
  failed: number
}

export type FixtureValidationEvolution = "improved" | "worsened" | "stable" | null

export type FixtureValidationRow = {
  id: number
  projectId: string
  projectName: string
  floorPlanReference: string
  sourceFilename: string | null
  validationStatus: FixtureValidationStatus
  validationReason: string | null
  expected: FixtureValidationCounts
  detected: FixtureValidationCounts
  createdAt: string
  evolution: FixtureValidationEvolution
}

export type FixtureValidationResultsResponse =
  | {
      success: false
      error: string
      code?: string
    }
  | {
      success: true
      summary: FixtureValidationSummary
      totalCount: number
      results: FixtureValidationRow[]
      warning?: string
    }
